export const GETGRAPHDATA = "GETGRAPHDATA"

export const REGISTERUSER = "REGISTERUSER"
export const LOGINUSER = "LOGINUSER"
export const LOGOUTUSER = "LOGOUTUSER"
export const FORGOTPASSWORD = "FORGOTPASSWORD"
export const RESETPASSWORD = "RESETPASSWORD"

export const GETPRED = "GETPRED"

